// console.log('🔧 DEBUG - Production Config:');
// console.log('  - process.env.REACT_APP_BACKEND_URL:', process.env.REACT_APP_BACKEND_URL);
// console.log('  - process.env.REACT_APP_BACKEND_PORT:', process.env.REACT_APP_BACKEND_PORT);

export default {
  HOST: process.env.REACT_APP_BACKEND_URL,
  PORT: process.env.REACT_APP_BACKEND_PORT
};
